// extracted by mini-css-extract-plugin
export var option = "_8i-0";
export var optionCard = "_8i-f";
export var optionContent = "_8i-g";
export var optionIcon = "_8i-i";
export var optionIconBox = "_8i-h";
export var optionLabel = "_8i-j";
export var optionPill = "_8i-m";
export var optionPillBadge = "_8i-p";
export var optionPillIcon = "_8i-n";
export var optionPillLabel = "_8i-o";
export var optionRadio = "_8i-k";
export var optionRadioInner = "_8i-l";
export var optionReveal = "_8i-2";
export var optionRevealDelay0 = "_8i-3";
export var optionRevealDelay1 = "_8i-4";
export var optionRevealDelay10 = "_8i-d";
export var optionRevealDelay11 = "_8i-e";
export var optionRevealDelay2 = "_8i-5";
export var optionRevealDelay3 = "_8i-6";
export var optionRevealDelay4 = "_8i-7";
export var optionRevealDelay5 = "_8i-8";
export var optionRevealDelay6 = "_8i-9";
export var optionRevealDelay7 = "_8i-a";
export var optionRevealDelay8 = "_8i-b";
export var optionRevealDelay9 = "_8i-c";
export var optionSelected = "_8i-1";